import { ConsultationDetail } from '../types';
import Icon from '../../../components/AppIcon';

interface ConsultationHeaderProps {
  consultation: ConsultationDetail;
}

const ConsultationHeader = ({ consultation }: ConsultationHeaderProps) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'success':
        return 'text-success bg-success/10';
      case 'api_error':
        return 'text-error bg-error/10';
      case 'validation_error':
        return 'text-warning bg-warning/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'success':
        return 'Concluída com Sucesso';
      case 'api_error':
        return 'Erro na API';
      case 'validation_error':
        return 'Erro de Validação';
      default:
        return 'Desconhecido';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 space-y-6">
      <div className="flex items-start justify-between">
        <div className="space-y-2">
          <div className="flex items-center gap-3">
            <h1 className="text-2xl font-semibold text-foreground">
              Consulta #{consultation.consultationNumber}
            </h1>
            <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(consultation.status)}`}>
              {getStatusLabel(consultation.status)}
            </span>
          </div>
          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <Icon name="Calendar" size={16} color="currentColor" />
              <span>{consultation.createdAt.toLocaleDateString('pt-BR')}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={16} color="currentColor" />
              <span>{consultation.createdAt.toLocaleTimeString('pt-BR')}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="User" size={16} color="currentColor" />
              <span>{consultation.createdBy}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-4">
          <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
            Informações da Empresa
          </h3>
          <div className="space-y-3">
            <div>
              <label className="text-xs text-muted-foreground">CNPJ</label>
              <p className="text-base text-foreground font-mono">{consultation.company.cnpj}</p>
            </div>
            <div>
              <label className="text-xs text-muted-foreground">Razão Social</label>
              <p className="text-base text-foreground">{consultation.company.name}</p>
            </div>
            <div>
              <label className="text-xs text-muted-foreground">Regime Tributário</label>
              <p className="text-base text-foreground">{consultation.company.taxRegime}</p>
            </div>
            <div className="flex gap-4">
              <div className="flex-1">
                <label className="text-xs text-muted-foreground">UF Origem</label>
                <p className="text-base text-foreground font-mono">{consultation.company.ufOrigin}</p>
              </div>
              <div className="flex-1">
                <label className="text-xs text-muted-foreground">UF Destino</label>
                <p className="text-base text-foreground font-mono">{consultation.company.ufDestination}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
            Parâmetros da Operação
          </h3>
          <div className="space-y-3">
            <div>
              <label className="text-xs text-muted-foreground">CFOP</label>
              <p className="text-base text-foreground font-mono">{consultation.operation.cfop}</p>
            </div>
            <div>
              <label className="text-xs text-muted-foreground">Finalidade</label>
              <p className="text-base text-foreground">{consultation.operation.purpose}</p>
            </div>
            <div>
              <label className="text-xs text-muted-foreground">Tipo de Operação</label>
              <p className="text-base text-foreground">{consultation.operation.operationType}</p>
            </div>
            <div>
              <label className="text-xs text-muted-foreground">Características Tributárias</label>
              <div className="flex flex-wrap gap-2 mt-1">
                {consultation.operation.taxCharacteristics.map((char, index) => (
                  <span
                    key={index}
                    className="px-2 py-1 bg-muted text-foreground text-xs rounded-md"
                  >
                    {char}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationHeader;